/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"
import { useBrowserLayout } from "gpages/hooks/layout"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import IconSymbols from "@src/components/iconSymbols"
import Footer from "@src/components/footer"
import { wxConfig, wxShare } from "@src/utils/wechat"

const Layout = ({ children, location }) => {
  const layoutMeta = useBrowserLayout()
  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])
  if (!layoutMeta.isReady) {
    return null
  }

  return (
    <AppContext.Provider value={layoutMeta}>
      <IconSymbols />
      <Seo />
      <Nav location={location} />
      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <Footer />
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
